// extracted by mini-css-extract-plugin
export var wrapper = "TriangleBlock-module--wrapper--++eP4";